// extracted by mini-css-extract-plugin
export default {"EmailNotVerifiedButton":"ProfilePage_EmailNotVerifiedButton__MhzNG"};